module.exports = function Worker_fn() {
  return new Worker(__webpack_public_path__ + "assets/download.worker.5067f2bb62e9ce382fbb.js");
}
